const prefix = 'indicator/';

export function removePrefix(fullRiskIndicator) {
  return fullRiskIndicator.replace(prefix, '')
}

export function appendPrefix(unprefixedRiskIndicator) {
  return prefix + unprefixedRiskIndicator
}
